<template>
  <main class="importPolicyCheck container-fluid mf_container pb_50 mb_50">
    <div v-show="is_ready">
      <h4 class="text-green mt_22">匯入保單健檢</h4>
      <div class="mt_17">
        <strong>{{ (this.isIV ? "" : "選擇要") + "匯入的建議" }}</strong>
      </div>
      <!-- 可選投資型報表 -->
      <OperateContractItemIV
        @isReady="updateReady"
        v-if="!isLoading && isIV"
        :contractData="proposal"
      ></OperateContractItemIV>
      <!-- 可選傳統型報表 -->
      <OperateContractItemTD
        @isReady="updateReady"
        v-else-if="!isLoading"
        selectedMode="checkbox"
        :contractData="proposal"
        @updateMCProdList="handleUpdate"
      ></OperateContractItemTD>
      <FixedBottom v-if="!isIV">
        <template slot="@function">
          <div class="d-flex justify-content-end mr_15">
            <router-link
              class="btn btn-default px_5 mr_10"
              to="/mf/query/queryDetail"
              >查詢其他建議書</router-link
            >
            <button
              @click="toImportPolicyCheck()"
              class="btn btn-primary px_5 mr_10"
              type="button"
              :disabled="!is_selected || waiting"
            >
              確定匯入
            </button>
          </div>
        </template>
      </FixedBottom>
    </div>
    <MfLoading :open="!is_ready" content="資料讀取中..." />
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import mf_Mixin from "@/desktop/views/mf/mixin";
import MfLoading from "@/desktop/views/mf/components/MfLoading";
import OperateContractItemTD from "@/desktop/views/mf/components/OperateContractItem_TD.vue";
import OperateContractItemIV from "@/desktop/views/mf/components/OperateContractItem_IV.vue";
import FixedBottom from "@/desktop/views/mf/components/fixedBotton";

export default {
  mixins: [mf_Mixin],
  components: {
    MfLoading,
    OperateContractItemTD,
    OperateContractItemIV,
    FixedBottom,
  },
  data() {
    return {
      proposal: {},
      waiting: false,
      proposalListScope: [],
      isLoading: true,
      is_selected: true,
      is_ready: false,
    };
  },
  computed: {
    ...mapGetters(["CustInfo", "UserInfo", "MfViewing"]),
    isIV() {
      return this.MfViewing.saveData.prod_type != "1";
    },
  },
  async created() {
    if (!this.MfViewing.prod_idx) {
      return this.$router.push("/mf/query");
    }
    this.updateClickDate();
    if (!this.isIV) {
      //傳統型呼叫
      let res = await this.$mfAPI.MFA0_1000__queryProposalDetailList({
        agent_id: this.$store.state.userInfo.id,
        insured_id: "",
        prod_idx: this.MfViewing.saveData.prod_idx,
      });
      this.proposal = res.proposal[0];
      this.isLoading = false;
      this.proposalListScope = this.proposal.mc_prod_list;
    } else {
      //投資型
      let res = await this.$mfAPI.MFA1_1000__queryProposalDetailList({
        agent_id: this.$store.state.userInfo.id,
        insured_id: "",
        prod_idx: this.MfViewing.saveData.prod_idx,
      });
      this.proposal = res.proposal[0];
      this.proposalListScope = this.proposal.mc_prod_list;
      await this.toImportPolicyCheck(); //投資型自動匯入
      this.isLoading = false; //匯入完成後才顯示畫面
    }
  },
  methods: {
    async toImportPolicyCheck() {
      this.waiting = true;
      if (this.$store.getters.BuTest) return;
      let toImportList;
      this.isIV
        ? (toImportList = this.proposalListScope)
        : (toImportList = this.proposalListScope.filter((item) => {
            return item.is_checked;
          }));

      if (toImportList.length > 0) {
        //檢核日額通算
        let checkDailyCalculateRes = await this.checkDailyCalculate({
          insured_age: this.MfViewing.saveData.insured_age,
          mc_prod_list: toImportList,
        });
        if (!checkDailyCalculateRes) return;
        //
        let valid = true;
        if (this.MfViewing.saveData.insurer_birthday == "") {
          valid = false;
          this.$toast.info({
            title: `匯入失敗! 要保人生日未輸入故無法使用本功能!`,
          });
        }
        if (this.MfViewing.saveData.insured_birthday == "") {
          valid = false;
          this.$toast.info({
            title: `匯入失敗! 主約被保人生日未輸入故無法使用本功能!`,
          });
        }
        var scFail = false;
        this.MfViewing.saveData.mc_prod_list.forEach((mc) => {
          mc.sc_prod_list.forEach((sc) => {
            if (sc.insured_birthday == "") {
              valid = false;
              scFail = true;
              return;
            }
          });
        });
        if (scFail) {
          this.$toast.info({
            title: `匯入失敗! 附約被保人生日未輸入故無法使用本功能!`,
          });
        }
        if (valid) {
          //發送API
          this.$mfAPI
            .MFA0_2000__importPolicyCheck({
              familyid: this.MfViewing.familyid,
              agent_id: this.$store.state.userInfo.id,
              proposalMap: {
                prod_idx: this.MfViewing.prod_idx || "", //建議書IDX
                insurer_name: this.MfViewing.insurer.insured_name,
                insurer_id: this.MfViewing.insurer.insured_id || "",
                insurer_gender: this.MfViewing.insurer.insured_gender,
                insurer_birthday: this.MfViewing.insurer.insured_birthday,
                insurer_age: this.MfViewing.insurer.insured_age + "",
                is_crm: this.MfViewing.inputType == "family" ? "1" : "0",
                insured_name: this.MfViewing.insured.insured_name,
                insured_id: this.MfViewing.insured.insured_id || "",
                insured_gender: this.MfViewing.insured.insured_gender,
                insured_birthday: this.MfViewing.insured.insured_birthday,
                insured_age: this.MfViewing.insured.insured_age + "",
                mc_prod_list: _.cloneDeep(toImportList),
              },
            })
            .then((res) => {
              this.waiting = false;
              this.$toast.info({
                title: `匯入成功!`,
              });
            })
            .catch((error) => {
              // this.$toast.info({
              //   title: `${error}`,
              // });
              this.waiting = false;
              this.$toast.info({ title: "執行失敗" });
            });
        }
      } else {
        this.$toast.info({ title: `請先勾選建議!` });
      }
    },
    handleUpdate(mc_prod_list) {
      this.proposalListScope = mc_prod_list;
      this.is_selected = false;
      this.proposalListScope.forEach((mc) => {
        if (mc.is_checked) {
          this.is_selected = true;
          return;
        }
        mc.sc_prod_list.forEach((sc) => {
          if (sc.is_checked) {
            this.is_selected = true;
          }
        });
      });
    },
    updateReady() {
      this.is_ready = true;
    },
  },
};
</script>
<style lang="scss">
.importPolicyCheck {
  color: #323a45;
  @media (min-width: 1025px) {
    width: 100%;
    max-width: 1280px;
  }
  &__proposalList {
    padding: 20px 0;
    &__item {
      display: flex;
      align-items: flex-start;
      border-bottom: solid 1px #e0e1e3;
    }
    .checkbox input + label:before {
      margin: 0;
    }
  }
}
</style>
